import { render, staticRenderFns } from "./ModalVigente.vue?vue&type=template&id=39c66ae9&"
import script from "./ModalVigente.vue?vue&type=script&lang=js&"
export * from "./ModalVigente.vue?vue&type=script&lang=js&"
import style0 from "./ModalVigente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports